import { render, staticRenderFns } from "./QuestionStatisticsDialog.vue?vue&type=template&id=6e15f0f0&"
import script from "./QuestionStatisticsDialog.vue?vue&type=script&lang=js&"
export * from "./QuestionStatisticsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports